import { render } from "./GenderEiProfileComparisonBlock.vue?vue&type=template&id=3b0bc644&scoped=true"
import script from "./GenderEiProfileComparisonBlock.vue?vue&type=script&lang=js"
export * from "./GenderEiProfileComparisonBlock.vue?vue&type=script&lang=js"

import "./GenderEiProfileComparisonBlock.vue?vue&type=style&index=0&id=3b0bc644&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0bc644"]])

export default __exports__